import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../common/utils/restApiHeaderUtils';
import { getCollectionFields, getCollectionFieldTraitOptions } from './plugins/pluginComponentApi';
const restrictedFields = ['password', 'updatedAt', 'createdBy', 'updatedBy', 'version'];
//TODO: This cannot be replaced as it is used in Link Traits
const getTraitCollectionFields = async (header, collectionName, projectId, version) => {
  const url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collections/${projectId}/project/${collectionName}/name`;
  return await axios.get(url, header);
};
export const getFieldsTraits = async (collectionName, projectId, version, collections) => {
  let collection = null;
  console.log('*** Version:', version);
  try {
    if (collections) {
      collection = await getCollectionFields(collectionName, collections);
    } else {
      const header = builderSurfaceJsonContentHeader(projectId);
      let { data } = await getTraitCollectionFields(header, collectionName, projectId, version);
      collection = data;
    }
  } catch (_err) {
    console.log('_err', _err);
  }
  let options = [];
  let collectionTitle = '';
  const collectionId = collectionName;
  if (collection && collection.collectionTitle) {
    options = await getCollectionFieldTraitOptions(collection, collections);
    collectionTitle = collection.collectionTitle;
  }
  return { options, collectionTitle, collectionId };
};

const getPageById = async (pageId, version, header) => {
  const url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/pages/${pageId}`;
  return axios.get(url, header);
};

const getSnippetById = async (projectId, version, snippetId, header) => {
  const url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/snippet-templates/${snippetId}`;
  return axios.get(url, header);
};
export const getPageCollectionFields = async (
  pageId,
  projectId,
  version,
  isLoginPlugin,
  collections,
  multiTenantPlugin,
) => {
  const header = builderSurfaceJsonContentHeader(projectId);
  const pageResponse = await getPageById(pageId, version, header);
  let response = [];
  const isMultiTenantPlugin = !!multiTenantPlugin;
  if (pageResponse && pageResponse.data) {
    response.page = pageResponse.data;
  }
  if (isLoginPlugin && pageResponse.data.access !== 'PERMIT_ALL') {
    const userFields = await getFieldsTraits('user', projectId, version, collections);
    userFields.options = userFields.options.filter((option) => {
      return !restrictedFields.includes(option.id);
    });
    response.session = userFields;
  }
  if (isMultiTenantPlugin) {
    console.log('*** Multi Tenant Plugin Installed.');
    const multiTenantCollection =
      collections && collections.find((collection) => collection.isTenantCollection);
    console.log('*** Multi Tenant Collection:', multiTenantCollection);
    const multiTenantFields = multiTenantCollection
      ? await getFieldsTraits(multiTenantCollection.collectionName, projectId, version, collections)
      : '';

    if (multiTenantFields && multiTenantFields.options) {
      multiTenantFields.options = multiTenantFields.options.filter((option) => {
        return !restrictedFields.includes(option.id);
      });
    }
    response.sessionTenant = multiTenantFields;
    const userSettingCollection =
      collections && collections.find((collection) => collection.isUserSettingCollection);
    const userSettingFields = userSettingCollection
      ? await getFieldsTraits(userSettingCollection.collectionName, projectId, version, collections)
      : '';

    if (userSettingFields && userSettingFields.options) {
      userSettingFields.options = userSettingFields.options.filter((option) => {
        return !restrictedFields.includes(option.id);
      });
    }
    response.sessionUserSettings = userSettingFields;
    const subTenantCollection =
      collections && collections.find((collection) => collection.isSubTenantCollection);
    const subTenantFields = subTenantCollection
      ? await getFieldsTraits(subTenantCollection.collectionName, projectId, version, collections)
      : '';

    if (subTenantFields && subTenantFields.options) {
      subTenantFields.options = subTenantFields.options.filter((option) => {
        return !restrictedFields.includes(option.id);
      });
    }
    response.sessionSubTenant = subTenantFields;
  }
  if (pageResponse.data.collectionId) {
    response.collection = await getFieldsTraits(
      pageResponse.data.collectionId,
      projectId,
      version,
      collections,
    );
  }
  return response;
};

export const getProjectById = async (projectId, version, header) => {
  const url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/`;
  return axios.get(url, header);
};

export const camelize = function (str) {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, '');
};

export const parameterize = function (str) {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return word.toLowerCase();
    })
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^a-zA-Z0-9]+/g, '-');
};

export const getSnippetCollectionFields = async (snippetId, projectId, version, collections) => {
  const header = builderSurfaceJsonContentHeader(projectId);
  const pageResponse = await getSnippetById(projectId, version, snippetId, header);
  console.log('==> SNIPPET COLLECTION FIELDS :>> ', pageResponse, snippetId, header);
  let response = [];
  if (pageResponse && pageResponse.data) {
    response.snippet = pageResponse.data;
    if (pageResponse.data.collectionId) {
      response.collection = await getFieldsTraits(
        pageResponse.data.collectionId,
        projectId,
        version,
        collections,
      );
    }
  }

  return response;
};

export const createRedirectUrl = () => {
  let domainName = window.location.hostname;
  let redirectUrl = `https://${domainName}/`;
  const environment = process.env.REACT_APP_ENVIRONMENT;
  if (environment === 'DEV') {
    redirectUrl = `http://${domainName}:9075/`;
  } else if (environment === 'STAGING') {
    domainName = domainName.replace('builder.webkonnect.digital', 'builderc.webkonnect.digital');
    redirectUrl = `https://${domainName}/`;
  } else {
    domainName = domainName.replace('builder.mydrapcode.com', 'builderc.mydrapcode.com');
    redirectUrl = `https://${domainName}/`;
  }
  return redirectUrl;
};

export const getAllTypesenseSearchTemplates = async (projectId, version) => {
  const header = builderSurfaceJsonContentHeader(projectId);
  const url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/templates?templateType=TYPESENSE_SEARCH`;
  const response = await axios.get(url, header);
  if (response && response.data && response.data.length) {
    return response.data;
  } else return [];
};
